import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const expertTopChoiceStylesUS: DomainsBaseStyles = {
  ...defaultStyles,

  COMMONS_APPBAR_BG: 'bg-[#D5367F]',
  COMMONS_APPBAR_TEXT: 'text-white',

  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',

  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',

  COMMONS_FOOTER_BG: 'bg-[#D5367F]',
  COMMONS_FOOTER_TEXT: 'text-white',

  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#85CD80] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',

  HOMEPAGE_HEADER_BG: 'bg-[#FFEEDF]',
  HOMEPAGE_HEADER_TEXT: 'text-black',

  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#D5367F]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#85CD80]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#85CD80] hover:border-[#85CD80] hover:bg-[#85CD80] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#D5367F]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#D5367F]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#D5367F]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#85CD80]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#464079] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#D5367F] text-[#D5367F] [&>svg>path]:stroke-[#D5367F] [&>svg>g>path]:stroke-[#D5367F] [&>svg>path]:fill-[#D5367F] [&>svg>g>path]:fill-[#D5367F]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#464079]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#D5367F]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#FFEEDF]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#85CD80]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#FFEEDF]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#D5367F] [&>.explore-icon-fill]:!fill-[#FFEEDF] [&>g>.explore-icon-fill]:!fill-[#FFEEDF]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFEEDF] [&>.vector-top>path]:fill-[#D5367F] [&>.vector-bottom>path]:fill-[#D5367F]',

  LISTPAGE_USER_VALUE_BADGE: 'text-[#D5367F] [&>div>svg>path]:fill-[#D5367F] bg-[#FFEEDF]',

  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#FFEEDF]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#D5367F]',

  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#85CD80]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-white',

  LISTPAGE_BADGE_WINNER_BG: 'bg-[#FFEEDF]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#D5367F]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#D5367F]',

  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#FFEEDF]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#D5367F]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#D5367F]',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#85CD80]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#FFEEDF]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#D5367F]',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#FFEEDF]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',

  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#D5367F]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#D5367F]',

  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#FFEEDF]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#D5367F]',

  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#464079] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#D5367F] text-[#D5367F] [&>svg>path]:stroke-[#D5367F] [&>svg>g>path]:stroke-[#D5367F] [&>svg>path]:fill-[#D5367F] [&>svg>g>path]:fill-[#D5367F]',
  LISTPAGE_BUTTON_LINK: 'text-[#464079]',
  LISTPAGE_ANCHOR_LINK: 'text-[#464079]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#464079]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#464079]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#464079]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#464079] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#D5367F] text-[#D5367F]  [&>svg>path]:stroke-[#D5367F] [&>svg>g>path]:stroke-[#D5367F] [&>svg>path]:fill-[#D5367F] [&>svg>g>path]:fill-[#D5367F]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#464079]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#464079]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#464079]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#464079]',

  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#464079]',

  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFEEDF] [&>.vector-top>path]:fill-[#D5367F] [&>.vector-bottom>path]:fill-[#D5367F]',

  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#FFEEDF] [&>circle]:stroke-[#FFEEDF] [&>path]:fill-[#D5367F]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#FFEEDF]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#464079]',

  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#FFEEDF]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-[#464079] bg-[#FFEEDF]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#464079]',

  UTILS_MAIN_CONTAINER: 'content-container-new-layout',
}

export const expertTopChoiceStylesCA: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#16A34A]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#16A34A]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#C2410C] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#E0FEE0]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#9747FF]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#FB923C] hover:border-[#FB923C] hover:bg-[#FB923C] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#FB923C]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#16A34A]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#16A34A]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#C2410C]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#16A34A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#16A34A] text-[#16A34A] [&>svg>path]:stroke-[#16A34A] [&>svg>g>path]:stroke-[#16A34A] [&>svg>path]:fill-[#16A34A] [&>svg>g>path]:fill-[#16A34A]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#16A34A]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#16A34A]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#E0FEE0]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#C2410C]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#E0FEE0]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#16A34A] [&>.explore-icon-fill]:!fill-[#E0FEE0] [&>g>.explore-icon-fill]:!fill-[#E0FEE0]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#E0FEE0] [&>.vector-top>path]:fill-[#16A34A] [&>.vector-bottom>path]:fill-[#16A34A]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#C2410C]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#FFEDD5]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#171717]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#C2410C]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#C2410C]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#C2410C]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#C2410C]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#166534]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#2C0065] ',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#2C0065]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#166534]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white ',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-white',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#171717]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#16A34A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#16A34A] text-[#16A34A] [&>svg>path]:stroke-[#16A34A] [&>svg>g>path]:stroke-[#16A34A] [&>svg>path]:fill-[#16A34A] [&>svg>g>path]:fill-[#16A34A]',
  LISTPAGE_BUTTON_LINK: 'text-[#16A34A]',
  LISTPAGE_ANCHOR_LINK: 'text-[#16A34A]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#16A34A]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#16A34A]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#16A34A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#16A34A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#16A34A] text-[#16A34A]  [&>svg>path]:stroke-[#16A34A] [&>svg>g>path]:stroke-[#16A34A] [&>svg>path]:fill-[#16A34A] [&>svg>g>path]:fill-[#16A34A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#16A34A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#16A34A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#16A34A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#16A34A]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#C2410C]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#16A34A]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#C2410C] [&>.vector-top>path]:fill-[#F69168] [&>.vector-bottom>path]:fill-[#F69168]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-[#F7F7F7]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#FFEDD5] [&>circle]:stroke-[#FFEDD5] [&>path]:fill-[#C2410C]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#FFEDD5]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#C2410C]',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#ECFCCB] data-[focus]:text-black text-black',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#65A30D] text-black',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#65A30D]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
